var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { cloneDeep } from 'lodash';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DynamicCatalogBuilder } from "../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DesktopTabComponent } from "../../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { secondaryTextGray } from "../../../../theme/palette";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { getBackgroundColor, getColor } from "../../../../utils/utils";
import { CancelIconSVG, DownloadIconSVG, EditIconSVG, PrintIconSVG, ShareOutlinedIconSVG } from "../assets/customIcons";
import CancelDocument from "../components/cancelDocument";
import { PurchaseRequisitionFilter } from "../components/purchaseRequisitionFilter";
import { cancellationReasonPRListAPICall, purchaseDetailsByProcurmentIdAPICall, purchaseRequisationPagingAPICall, purchaseRequisitionCancelAPICall, purchaseRequisitionGetAPICall } from "../services/apiCall";
import { purchaseRequisationPagingAPI, PurchaseRequisitionKeys, viewTypeOptions } from "../services/entity";
import HeaderCatalogPageComponent from "../../../../components/templates/headerCatalogPageUpdated";
import { showSurface } from "../../../../redux/awaitedSurfacesSlice";
var PurchaseRequisition = function () {
    var _crud$filterValue, _crud$PurchaseRequisi;
    var crud = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; });
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), openFilter = _b[0], setOpenFilter = _b[1];
    var _c = useState(false), openCancelPopUp = _c[0], setOpenCancelPopUp = _c[1];
    var _d = useState(''), rowId = _d[0], setRowId = _d[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var navigate = useNavigate();
    var filterValue = (_crud$filterValue = crud['filterValue']) === null || _crud$filterValue === void 0 ? void 0 : _crud$filterValue.data;
    var dispatch = useAppDispatch();
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var _e = useState(viewTypeOptions.length > 0 && isAllViewActive ? viewTypeOptions[0] : viewTypeOptions[1]), selectedListVariant = _e[0], setSelectedListVariant = _e[1];
    var getIcon = function (name) {
        switch (name) {
            case 'Edit':
                return /*#__PURE__*/ React.createElement(EditIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Cancel':
                return /*#__PURE__*/ React.createElement(CancelIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Print':
                return /*#__PURE__*/ React.createElement(PrintIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'DownloadPDF':
                return /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Share':
                return /*#__PURE__*/ React.createElement(ShareOutlinedIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var handleClickFilterIcon = function () {
        setOpenFilter(function (prev) { return !prev; });
    };
    var getRequest = function () {
        var _filterValue$ToDate, _filterValue$Status, _getLocalStorageItem, _filterValue$Type, _filterValue$Priority;
        var request = {
            FromDate: filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate,
            ToDate: (_filterValue$ToDate = filterValue === null || filterValue === void 0 ? void 0 : filterValue.ToDate) !== null && _filterValue$ToDate !== void 0 ? _filterValue$ToDate : filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate,
            Status: filterValue === null || filterValue === void 0 || (_filterValue$Status = filterValue.Status) === null || _filterValue$Status === void 0 ? void 0 : _filterValue$Status.map(function (item) { return item === null || item === void 0 ? void 0 : item.Name; }),
            IdentityId: selectedListVariant === "My requisitions" ? (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId : undefined
        };
        if ((filterValue === null || filterValue === void 0 || (_filterValue$Type = filterValue.Type) === null || _filterValue$Type === void 0 ? void 0 : _filterValue$Type.length) > 0) {
            var _filterValue$Type2;
            request = _objectSpread(_objectSpread({}, request), {}, {
                Type: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.Type) && (filterValue === null || filterValue === void 0 || (_filterValue$Type2 = filterValue.Type) === null || _filterValue$Type2 === void 0 ? void 0 : _filterValue$Type2.map(function (item) { return item.ProcurementTypeId; }))
            });
        }
        if ((filterValue === null || filterValue === void 0 || (_filterValue$Priority = filterValue.Priority) === null || _filterValue$Priority === void 0 ? void 0 : _filterValue$Priority.length) > 0) {
            var _filterValue$Priority2;
            request = _objectSpread(_objectSpread({}, request), {}, {
                Priority: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.Priority) && (filterValue === null || filterValue === void 0 || (_filterValue$Priority2 = filterValue.Priority) === null || _filterValue$Priority2 === void 0 ? void 0 : _filterValue$Priority2.map(function (item) { return item.Name; }))
            });
        }
        return request;
    };
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var customActionColumns = [{
            field: 'SrNo',
            headerName: 'Sr. No',
            width: 50,
            valueFormatter: function (val, row, col, api) { return api.current.getRowIndexRelativeToVisibleRows(row.id) + 1; },
            sortable: false
        }, {
            field: 'DocumentNumber',
            headerName: 'Requisition Number',
            minWidth: 200,
            flex: 1
        }, {
            field: 'PurchaseProcurementTypeName',
            headerName: 'PR Type',
            minWidth: 200,
            flex: 1
        }, {
            field: 'StatusName',
            headerName: 'Status',
            renderCell: function (params) { return params !== null && params !== void 0 && params.formattedValue ? /*#__PURE__*/ React.createElement(Chip, {
                label: params.formattedValue,
                size: "small",
                variant: "outlined",
                id: 'status',
                sx: {
                    borderRadius: 2,
                    px: 1,
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'black'
                },
                icon: params.formattedValue == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                    height: 8,
                    width: 8,
                    borderRadius: 10,
                    bgcolor: "red"
                }) : undefined
            }) : '-'; },
            minWidth: 100
        }, {
            field: 'ProcurementPriorityName',
            headerName: 'Priority',
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Chip, {
                label: (params === null || params === void 0 ? void 0 : params.formattedValue) || '-',
                size: "small",
                variant: "outlined",
                id: 'priority-name',
                sx: {
                    borderRadius: '6px',
                    color: getColor(params === null || params === void 0 ? void 0 : params.formattedValue),
                    backgroundColor: getBackgroundColor(params === null || params === void 0 ? void 0 : params.formattedValue),
                    border: 'none',
                    px: 1,
                    py: '2px'
                }
            }); },
            minWidth: 100
        }, {
            field: 'EstimateDeliveryDateTime',
            headerName: 'Delivery Date',
            minWidth: 120,
            valueFormatter: function (val) { return val ? dayjs(val).format('DD MMM, YYYY') : '-'; },
            flex: 1
        }, {
            field: 'CreatedByFirstName',
            headerName: 'Created By',
            valueFormatter: function (val, row) {
                var _row$CreatedByFirstNa, _row$CreatedByLastNam;
                return row !== null && row !== void 0 && row.CreatedByLastName || row !== null && row !== void 0 && row.CreatedByFirstName ? "".concat((_row$CreatedByFirstNa = row === null || row === void 0 ? void 0 : row.CreatedByFirstName) !== null && _row$CreatedByFirstNa !== void 0 ? _row$CreatedByFirstNa : '', " ").concat((_row$CreatedByLastNam = row === null || row === void 0 ? void 0 : row.CreatedByLastName) !== null && _row$CreatedByLastNam !== void 0 ? _row$CreatedByLastNam : '') : '-';
            },
            minWidth: 200,
            flex: 1
        }, {
            field: 'ProcurementCreatedDateTime',
            headerName: 'Created Date',
            valueFormatter: function (val) { return val ? dayjs(val).format('DD MMM, YYYY') : '-'; },
            minWidth: 120,
            flex: 1
        }, {
            field: 'ScheduledDateTime',
            headerName: 'Scheduled For PO',
            valueFormatter: function (val) { return val ? dayjs(val).format('DD MMM, YYYY') : '-'; },
            minWidth: 120,
            flex: 1
        }, {
            field: 'Amount',
            headerName: 'Amount',
            valueFormatter: function (val) {
                var _Number;
                return (_Number = Number(val)) === null || _Number === void 0 ? void 0 : _Number.toFixed(2);
            },
            minWidth: 80,
            align: 'right',
            headerAlign: 'right',
            flex: 1
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _params$row;
                var menuFeatures = cloneDeep(storedMenuFeatures);
                var list = menuFeatures === null || menuFeatures === void 0 ? void 0 : menuFeatures.filter(function (data) { return !(data.Name == 'Cancel' || data.Name == 'Edit'); });
                var data = (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.StatusName) === 'Cancelled' ? list : storedMenuFeatures !== null && storedMenuFeatures !== void 0 ? storedMenuFeatures : [];
                return data === null || data === void 0 ? void 0 : data.map(function (data) {
                    var _a;
                    return React.createElement(GridActionsCellItem, {
                        label: data === null || data === void 0 ? void 0 : data.DisplayName,
                        icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                        id: "action-icon",
                        showInMenu: true,
                        divider: (data === null || data === void 0 ? void 0 : data.Name) === 'Cancel',
                        onClick: function () {
                            if ((data === null || data === void 0 ? void 0 : data.Name) == 'Edit') {
                                var _params$row2;
                                handleRowEditClick(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.id);
                            }
                            if ((data === null || data === void 0 ? void 0 : data.Name) == 'Cancel') {
                                var _params$row3;
                                handleRowCancelClick(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.id);
                            }
                        },
                        sx: (_a = {
                                fontSize: 14
                            },
                            _a["& .MuiListItemIcon-root"] = {
                                minWidth: 24
                            },
                            _a)
                    });
                });
            },
            minWidth: 50
        }];
    useEffect(function () {
        purchaseRequisationPagingAPICall({
            key: PurchaseRequisitionKeys.Paging,
            request: getRequest(),
            url: purchaseRequisationPagingAPI
        });
    }, [selectedListVariant, filterValue]);
    var handleRowEditClick = function (id) {
        navigate("/purchaseRequisition/createPurchaseRequisition/".concat(id, "?mode=edit"));
    };
    var handleRowCancelClick = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRowId(id);
                    return [4 /*yield*/, dispatch(showSurface(_objectSpread(_objectSpread({}, IS_MOBILE ? {
                            type: 'Drawer',
                            containerProps: {
                                PaperProps: {
                                    sx: {
                                        p: 2,
                                        width: {
                                            xs: '100%',
                                            sm: '400px'
                                        },
                                        borderRadius: 2
                                    }
                                },
                                anchor: 'bottom'
                            }
                        } : {
                            type: 'Dialog',
                            containerProps: {
                                maxWidth: 'sm'
                            }
                        }), {}, {
                            Component: function (_ref) {
                                var onClose = _ref.onClose;
                                return /*#__PURE__*/ React.createElement(CancelDocument, {
                                    openPopper: openCancelPopUp,
                                    cancellationReasonAPI: cancellationReasonPRListAPICall,
                                    cancelAPI: purchaseRequisitionCancelAPICall,
                                    id: rowId,
                                    handleClose: onClose
                                });
                            }
                        })))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRowClick = function (event) {
        // setRowData(event?.row)
        purchaseRequisitionGetAPICall({
            request: {
                id: event === null || event === void 0 ? void 0 : event.id
            }
        });
        var request = {
            PurchaseProcurementId: event === null || event === void 0 ? void 0 : event.id
        };
        purchaseDetailsByProcurmentIdAPICall({
            request: request
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: viewTypeOptions
    }), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: viewTypeOptions.length > 0 ? viewTypeOptions : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$PurchaseRequisi = crud[PurchaseRequisitionKeys.Paging]) === null || _crud$PurchaseRequisi === void 0 ? void 0 : _crud$PurchaseRequisi.count,
        onClickCreateModule: function () {
            navigate('./createPurchaseRequisition?mode=add');
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.PurchaseRequisition
    }), /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: PurchaseRequisitionKeys.Paging,
        getPagingData: purchaseRequisationPagingAPICall,
        pagingAPIRequest: getRequest(),
        columns: customActionColumns,
        dataGridProps: {
            onCellClick: function (params) {
                if (!(params.field == 'actions')) {
                    handleRowClick(params);
                }
            },
            disableColumnMenu: false
        }
    })), /*#__PURE__*/ React.createElement(PurchaseRequisitionFilter, {
        isFilterOpen: openFilter,
        setFilterOpen: handleClickFilterIcon
    }));
};
export default PurchaseRequisition;
